import type { IMarketplaceDropDown } from '@/pages/dashboard-search/types';
import { Marketplace } from '@/store/organization/projectSlice';
import wbIcon from '../images/markeplaces/icons/wildberries.png';

export const marketplacesWithAds = [
  Marketplace.Wildberries,
  Marketplace.YandexMarket,
  Marketplace.EApteka,
  Marketplace.Zdravcity,
];

export const marketplaces: Partial<IMarketplaceDropDown> = {
  [Marketplace.Ozon]: {
    title: 'OZON',
    icon: '../images/markeplaces/icons/ozon.png',
  },
  [Marketplace.Wildberries]: {
    title: 'Wildberries',
    icon: wbIcon,
  },
  [Marketplace.YandexMarket]: {
    title: 'YandexMarket',
    icon: '../images/markeplaces/icons/ym.jpeg',
  },
  [Marketplace.Perekrestok]: {
    title: 'Перекресток',
    icon: '../images/markeplaces/icons/perekrestok.png',
  },
  [Marketplace.Pyaterochka]: {
    title: 'Пятерочка',
    icon: '../images/markeplaces/icons/pyaterochka.png',
  },
  [Marketplace.Magnit]: {
    title: 'Магнит',
    icon: '../images/markeplaces/icons/magnit.jpg',
  },
  [Marketplace.KuperMagnit]: {
    title: 'Kuper Магнит',
    icon: '../images/markeplaces/icons/magnit.jpg',
  },
  [Marketplace.MagnitCosmetic]: {
    title: 'Магнит Косметик',
    icon: '../images/markeplaces/icons/magnit-cosm.png',
  },
  [Marketplace.Vprok]: {
    title: 'Впрок',
    icon: '../images/markeplaces/icons/vprok.png',
  },
  [Marketplace.Metro]: {
    title: 'Метро',
    icon: '../images/markeplaces/icons/metro.png',
  },
  [Marketplace.DetMir]: {
    title: 'Детский Мир',
    icon: '../images/markeplaces/icons/detmir.png',
  },
  [Marketplace.MVideo]: {
    title: 'МВидео',
    icon: '../images/markeplaces/icons/mvideo.svg',
  },
  [Marketplace.Lenta]: {
    title: 'Лента',
    icon: '../images/markeplaces/icons/lenta.jpg',
  },
  [Marketplace.GoldApple]: {
    title: 'Золотое Яблоко',
    icon: '../images/markeplaces/icons/goldapple.png',
  },
  [Marketplace.VkusVill]: {
    title: 'ВкусВилл',
    icon: '../images/markeplaces/icons/vkusvill.jpg',
  },
  [Marketplace.KuperPyaterochka]: {
    title: 'Купер Пятерочка',
    icon: '../images/markeplaces/icons/pyaterochka.png',
  },
  [Marketplace.KuperPerekrestok]: {
    title: 'Купер Перекресток',
    icon: '../images/markeplaces/icons/perekrestok.png',
  },
  [Marketplace.KuperVprok]: {
    title: 'Купер Впрок',
    icon: '../images/markeplaces/icons/vprok.png',
  },
  [Marketplace.KuperLenta]: {
    title: 'Купер Лента',
    icon: '../images/markeplaces/icons/lenta.jpg',
  },
  [Marketplace.KuperSuperLenta]: {
    title: 'Купер Супер Лента',
    icon: '../images/markeplaces/icons/lenta.jpg',
  },
  [Marketplace.KuperAuchan]: {
    title: 'Купер Ашан',
    icon: '../images/markeplaces/icons/auchan.png',
  },
  [Marketplace.Aptekaru]: {
    title: 'АптекаRu',
    icon: '../images/markeplaces/icons/aptekaru.png',
  },
  [Marketplace.EApteka]: {
    title: 'E-Аптека',
    icon: '../images/markeplaces/icons/eapteka.png',
  },
  [Marketplace.Zdravcity]: {
    title: 'Здравcити',
    icon: '../images/markeplaces/icons/zdravcity.png',
  },
  [Marketplace.Asna]: {
    title: 'Асна',
    icon: '../images/markeplaces/icons/asna.png',
  },
  [Marketplace.Uteka]: {
    title: 'Ютека',
    icon: '../images/markeplaces/icons/uteka.png',
  },
};
